import React from "react"

const Footer = () => (
    <div className="justify-self-end mt-auto pt-16 mb-4 text-gray-400">
        Made by <a href="https://uly.dev" target="_blank" rel="noopener noreferrer" className="text-blue-500">ulydev</a> (<a href="https://github.com/ulydev/contract-admin" target="_blank" rel="noopener noreferrer" className="text-blue-500">repo</a>). Enjoying it? Buy me a coffee at<br/>
        <span className="font-bold text-gray-600">0xffd91D21aada737a54902E5C09f4af5A8E52252D</span>
    </div>
)

export default Footer